export const graphConfiguration = {
    title: {
        text: "Total listens",
        align: "left", // Align the title to the left
        style: {
            color: "#2A2F3B", // Title color
            fontSize: "16px", // Title font size
            fontWeight: "700", // Title font weight
            fontFamily: "Nunito Sans" // Custom font familycssClass: "apexcharts-title" // Custom CSS class (optional)
        }
    },
    chart: {
        toolbar: "false",
        dropShadow: {
            enabled: !0,
            color: "#000",
            top: 18,
            left: 7,
            blur: 8,
            opacity: 0.2
        },
        events: {
            legendClick: function (chartContext, seriesIndex) {
                let series = chartContext.w.globals.series;
                let activeSeries = series.filter(
                    (s, i) => chartContext.w.globals.collapsedSeriesIndices.indexOf(i) === -1
                );

                if (activeSeries.length === 1 && activeSeries[0] === seriesIndex) {
                    return false; // Prevent hiding the last active series
                }
            }
        }
    },
    dataLabels: {
        enabled: !1
    },
    colors: ["#7DA7B9", "#B97DA7"],
    stroke: {
        curve: "smooth",
        width: 3
    },
    yaxis: {
        showAlways: true,
        title: {
            text: "",
            rotate: -90,
            offsetX: 0,
            offsetY: 0
        },
        labels: {
            formatter: function (val) {
                if (!val) return val;
                return val.toFixed(0);
            }
        }
    },
    tooltip: {
        shared: false, // Prevents highlighting multiple series
        intersect: true, // Ensures only the hovered point is highlighted
        y: {
            formatter: function (val) {
                if (!val) return val;
                return val.toFixed(0);
            }
        }
    },
    legend: {
        show: true,
        position: "top", // Positions the legend at the top
        horizontalAlign: "right", // Aligns the legend to the right
        offsetY: 0,
        offsetX: 0,
        onItemHover: {
            highlightDataSeries: false // Prevents multiple series from highlighting
        },
        markers: {
            width: 12,
            height: 12,
            radius: 0, // Set radius to 0 for square markers
            shape: "square" // Set shape to square
        },
        labels: {
            colors: ["#333"], // Customize label color
            useSeriesColors: false
        },
        itemMargin: {
            horizontal: 10,
            vertical: 0
        }
    },

    noData: {
        text: "Data Not Found",
        align: "center",
        verticalAlign: "middle"
    }
};
